// @flow
import {
	connectWebActions,
	connectWebComponents,
	autoTitleLinksWithBlankTarget,
	safeBlankLinks,
} from 'fg-frontend';
import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import cookiesPolicy from './components/CookiesPolicy';
import menuScroll from './components/menuScroll';
import customHighslide from './components/customHighslide';
import wiper from './components/wiper';
import visor from './components/visor';
import phoneLink from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';
import 'bootstrap/collapse';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
// autoTitleLinksWithBlankTarget();
cookiesPolicy();
phoneLink();
menuScroll();
customHighslide();
wiper();
visor();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/configureWeb.js